export class ToastData {
    text: string;
    backgroundColor: string;
    textColor: string;
    icon: string;
    delay: number;

    constructor(toastData: IToastData) {
        this.text = toastData.text;
        this.backgroundColor = toastData.backgroundColor;
        this.textColor = toastData.textColor;
        this.icon = toastData.icon;
        this.delay = toastData.delay;
    }

}

export interface IToastData {
    text: string;
    backgroundColor: string;
    textColor: string;
    icon: string;
    delay: number;
}

